import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M21.81,3.85,18.4.44A1.52,1.52,0,0,0,17.34,0H6.75a1.5,1.5,0,0,0-1.5,1.5V19a1.5,1.5,0,0,0,1.5,1.5h14a1.5,1.5,0,0,0,1.5-1.5V4.91A1.52,1.52,0,0,0,21.81,3.85Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M17.75,22h-13a1,1,0,0,1-1-1V3.5a1,1,0,0,0-2,0V21a3,3,0,0,0,3,3h13a1,1,0,0,0,0-2Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }